import axios from 'axios';

export interface ApiError extends Error {
  status?: number | undefined;
  code?: string | undefined;
  details?: any;
}

export class ApiErrorHandler {
  static handle(error: any): never {
    if (axios.isAxiosError(error)) {
      const apiError = new Error(
        error.response?.data?.message || 
        error.message || 
        'API request failed'
      ) as ApiError;
      
      apiError.status = error.response?.status;
      apiError.code = error.code;
      apiError.details = error.response?.data;
      
      throw apiError;
    }
    
    const genericError = new Error('An unexpected error occurred') as ApiError;
    throw genericError;
  }

  static isNotFoundError(error: any): boolean {
    const apiError = error as ApiError;
    const message = typeof error?.message === 'string' ? error.message : '';
    const detailsCode = Number(apiError?.details?.code);

    return (
      message.includes('404') ||
      apiError?.status === 404 ||
      detailsCode === 404
    );
  }
}
